import cn from "classnames";
import {AppFlex} from "shared/UI/UIKit/Flex";
import {AppText} from "shared/UI/UIKit/Text";
import {AppNavLink} from "shared/UI/UIKit/Link";
import {AppLiteratureIcon} from "shared/UI/UIKit/icons/Literature";
import {AppVideoIcon} from "shared/UI/UIKit/icons/Video";
import {AppTheoryIcon} from "shared/UI/UIKit/icons/Theory";
import {AppJobIcon} from "shared/UI/UIKit/icons/Job";
import {
  getInteractiveUrl,
  getVideoUrl,
  getAdditionalMaterialsUrl,
  getAnnotationUrl,
  getMethodologicalModuleUrl,
  getPracticalModuleUrl, getLiteratureUrl,
} from "services/navigation";
import type {FunctionComponent} from "react";
import type {AppIconProps} from "shared/UI/UIKit/icons/Icons.types";
import {GLOBAL_CONFIG} from "../../../../config/config";
import {PageType} from "../../../../config/types";
import styles from "./Sidebar.module.scss";

type SidebarLinkProps = {
  to: string;
  title: string;
  Icon: FunctionComponent<AppIconProps>;
}

const SidebarLink = (props: SidebarLinkProps) => {
  const {Icon} = props;

  return (
    <AppNavLink to={props.to} className={styles.link}>
      {
          ({isActive}) => {
            return (
              <AppFlex direction="row" unit="30" alignItems="center">
                <Icon className={cn(styles.icon, isActive && styles.active)}/>
                <AppText secondary size={20} weight={isActive ? 600 : 400} className={styles.navLinkTitle}>
                  {props.title}
                </AppText>
              </AppFlex>
            );
          }
        }
    </AppNavLink>
  );
};

export const AppSidebar = () => {
  return (
    <aside className={styles.sidebar}>
      <AppFlex unit="20">
        {
          GLOBAL_CONFIG.pages.map((page, index) => {
            switch (page.type) {
              case PageType.ANNOTATION:
                return <SidebarLink Icon={AppTheoryIcon} key={index} title="Aннотация" to={getAnnotationUrl()}/>;
              case PageType.INTERACTIVE:
                return <SidebarLink Icon={AppJobIcon} key={index} title={page.title} to={getInteractiveUrl({id: page.id})}/>;
              case PageType.LITERATURE:
                return <SidebarLink Icon={AppLiteratureIcon} key={index} title="Литература" to={getLiteratureUrl()}/>;
              // case PageType.TARGET:
              //   return <SidebarLink Icon={AppTargetIcon} key={index} title="Цели" to={getTargetUrl()}/>;
              // case PageType.TEST:
              //   return <SidebarLink Icon={AppTestIcon} key={index} title="Контроль" to={getTestUrl()}/>;
              // case PageType.THEORY:
              //   return <SidebarLink Icon={AppTheoryIcon} key={index} title="Теория" to={getTheoryUrl()}/>;
              case PageType.VIDEO:
                return <SidebarLink Icon={AppVideoIcon} key={index} title="Видео" to={getVideoUrl()}/>;
              case PageType.METHODOLOGICAL_MODULE:
                return <SidebarLink key={index} to={getMethodologicalModuleUrl({id: page.id})} title={page.title} Icon={AppVideoIcon}/>;
              case PageType.PRACTICAL_MODULE:
                return <SidebarLink key={index} to={getPracticalModuleUrl({id: page.id})} title={page.title} Icon={AppJobIcon}/>;
              case PageType.ADDITIONAL_MATERIALS:
                return <SidebarLink key={index} to={getAdditionalMaterialsUrl()} Icon={AppLiteratureIcon} title="Дополнительный модуль"/>;
            }
          })
        }
      </AppFlex>
    </aside>
  );
};
